import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { AddResourceSetResourcesRequest } from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export type UseAddResourceSetResourcesMutationParams = {
  resourceSetId: string
}

export function useAddResourceSetResourcesMutation(
  params: UseAddResourceSetResourcesMutationParams,
  options?: UseMutationOptions<void, AddResourceSetResourcesRequest>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (request: AddResourceSetResourcesRequest) =>
      pqClient.addResourceSetResources(params.resourceSetId, request),
  })

  return { addResourceSetResources: mutateAsync, ...mutationResult }
}
